export enum ActivationStepsEnum {
    enterMail = 1,
    verifyUser,
}
